import React from "react";

const MAP = {
  matched: { label: "Matched", cls: "bg-[#EBF7EE] text-pp-forest" },
  multiple: { label: "Multiple matches", cls: "bg-[#FFF3D6] text-[#8A5F00]" },
  needs_clarification: { label: "Needs clarification", cls: "bg-[#E8F1FC] text-[#1E4F8A]" },
  no_match: { label: "No nearby match", cls: "bg-[#FDF0ED] text-pp-error" },
  best_price: { label: "Best price found", cls: "bg-[#78C442]/20 text-pp-forest" },
  substitute: { label: "Possible substitute", cls: "bg-[#E8F1FC] text-[#1E4F8A]" },
  unavailable: { label: "Price unavailable", cls: "bg-[#F3F1EC] text-pp-muted" },
};

export default function StateBadge({ state, testId }) {
  const s = MAP[state] || MAP.matched;
  return (
    <span data-testid={testId || `state-${state}`}
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-semibold ${s.cls}`}>
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {s.label}
    </span>
  );
}
